// client/src/components/map/usePulseAnimation.ts
//
// The pulsing-ring mark on a maplibre map (ST-00276 phase 2): animates the pulse layers
// (map/assetDisplay animatePulse) only while `active` — some vehicle on the map carries a pulse
// mark — and stops when it no longer does, when the map goes, or on unmount. With reduced motion
// the ring stays steady (animatePulse does nothing). No timer runs for a map without pulses.

import { useEffect } from 'react';
import type { Map as MaplibreMap } from 'maplibre-gl';
import { animatePulse } from './assetDisplay';

export default function usePulseAnimation(
  map: MaplibreMap | null,
  layerIds: readonly string[],
  size: number,
  active: boolean
): void {
  const ids = layerIds.join('|');
  useEffect(() => {
    if (!map || !active) return undefined;
    return animatePulse(map, ids.split('|'), size);
  }, [map, ids, size, active]);
}
